import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import { AuthController } from '../controllers/auth-controller';
import { NotificationsController } from '../controllers/notifications-controller';
import { SubscriptionController } from '../controllers/subscription-controller';

@customElement('notification-count-badge')
export class NotificationCountBadge extends LitElement {
    authController = new AuthController(this);
    subscriptionController = new SubscriptionController(this);
    notificationsController = new NotificationsController(this, this.authController);

    createRenderRoot() {
        return this;
    }

    get isLogged() {
        return this.authController.isLogged;
    }

    get isPhoneNumberSet() {
        return this.authController.user?.phoneNumber;
    }

    get unreadCount() {
        let extraNotification = !this.isPhoneNumberSet ? 1 : 0;

        if (this.subscriptionController.showNotification) {
            extraNotification = extraNotification + 1;
        }

        return this.notificationsController.unreadCount + extraNotification;
    }

    render() {
        if (!this.isLogged || !this.unreadCount) return nothing;
        return html` <div class="notification-badge"></div> `;
    }
}
